import { useState } from "react";
import { useSetError } from "../../../generic-error";
import TransmedProcessSlide from "./slide";
import { useRevalidator } from "react-router-dom";
import subtractOneSecond from "../../../../utils/subtractOneSecond";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import TextInput from "../../../../components/inputs/text";
import { CircularProgress } from "@mui/material";
import TransmedRegistrationContestationService from "../../../../service/transmed/process/registration/contestation";

function TransmedProcessRejected(props: {
  rejection_message: string | null;
  question: string | null;
  answer: string | null;
  contesting_deadline: Date;
}) {
  const revalidator = useRevalidator();
  const setErrorOnly = useSetError();
  const setError = (error: unknown) => {
    setErrorOnly(error);
    revalidator.revalidate();
  };
  const [loading, setLoading] = useState<boolean>(false);

  const [question, setQuestion] = useState<string>(props.question ?? "");
  const dimensions = useWindowDimensions();

  const allowContesting = () => {
    return props.question === null && new Date() < props.contesting_deadline;
  };

  return (
    <TransmedProcessSlide>
      <h3>Înscrierea ta a fost respinsă</h3>
      <span style={{ marginTop: "var(--gap-big)" }}>
        {props.rejection_message}
      </span>
      <form
        style={{
          marginTop: "var(--gap-big)",
          display: "flex",
          flexDirection: "column",
          alignContent: "flex-start",
          gap: "var(--gap-small)",
        }}
        onSubmit={async (e) => {
          e.preventDefault();

          setError("");
          setLoading(true);
          try {
            if (question.trim().length === 0)
              throw new Error("Nu poți contesta fără o întrebare.");
            await new TransmedRegistrationContestationService().create.contestation(
              question
            );
            revalidator.revalidate();
          } catch (error) {
            setError(error);
          } finally {
            setLoading(false);
          }
        }}
      >
        <span>
          Dacă ești nemulțumit de rezultat sau consideri că s-a produs vreo
          greșală, poți depune o contestație până în:{" "}
          <b>
            {subtractOneSecond(props.contesting_deadline).toLocaleDateString(
              "RO-ro"
            )}
            , ora{" "}
            {subtractOneSecond(props.contesting_deadline).toLocaleTimeString(
              "RO-ro"
            )}
          </b>
        </span>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: dimensions.width > 550 ? "1fr 1fr" : "1fr",
            gap: "var(--gap-small)",
          }}
        >
          <h4>Contestație</h4>
          <TextInput
            multiline
            required
            rows={6}
            style={{ gridRowStart: 2, gridRowEnd: 2 }}
            InputProps={{
              readOnly: !allowContesting(),
            }}
            onKeyDown={(e) => {
              if (!allowContesting()) e.preventDefault();
            }}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            disabled={false}
            sx={{
              "& .MuiInputBase-root": {
                paddingTop: "12px",
              },
            }}
          />
          <h4>Răspuns</h4>
          <TextInput
            multiline
            rows={6}
            InputProps={{
              readOnly: true,
            }}
            onKeyDown={(e) => e.preventDefault()}
            value={props.answer}
            sx={{
              "& .MuiInputBase-root": {
                paddingTop: "12px",
              },
            }}
          />
        </div>
        <div style={{ display: "flex", gap: "var(--gap-small)" }}>
          <button
            type="submit"
            className="primary button"
            style={{ alignSelf: "flex-start" }}
            disabled={!allowContesting()}
          >
            Depune Contestație
          </button>
          {(loading || revalidator.state === "loading") && <CircularProgress />}
        </div>
      </form>
    </TransmedProcessSlide>
  );
}

export default TransmedProcessRejected;
